"use client";

import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox";
import { Check } from "lucide-react";

import { cn } from "frontend-components/lib/utils";

function Checkbox({ className, ...props }: CheckboxPrimitive.Root.Props & { className?: string }) {
    return (
        <CheckboxPrimitive.Root
            data-slot="checkbox"
            className={cn(
                "peer inline-flex size-4 shrink-0 items-center justify-center rounded border border-input bg-background text-primary shadow-xs outline-none transition-[color,box-shadow] focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground data-[indeterminate]:border-primary data-[indeterminate]:bg-primary data-[indeterminate]:text-primary-foreground aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
                className,
            )}
            {...props}
        >
            <CheckboxPrimitive.Indicator
                data-slot="checkbox-indicator"
                keepMounted
                className="flex items-center justify-center text-current data-[unchecked]:invisible [&[data-indeterminate]>svg]:hidden [&[data-indeterminate]>span]:block"
            >
                <Check className="size-3" />
                <span className="hidden h-0.5 w-2 rounded-full bg-current" />
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
    );
}

export { Checkbox };
